/* eslint-disable react/prop-types */
import { Box, Tooltip } from "@mui/material";

export default function TimelineChart({ trackerList, runningTask, date }) {
    const activeHours = trackerList?.map((tracker) => {
        const startMinutes = (new Date(tracker?.startTime).getHours() * 60) + new Date(tracker?.startTime).getMinutes()
        const stopMinutes = (new Date(tracker?.stopTime).getHours() * 60) + new Date(tracker?.stopTime).getMinutes()
        const startHour = startMinutes / 60;
        const stopHour = stopMinutes / 60;
        return ([startHour, stopHour])
    })
    const isRunning = runningTask && new Date(runningTask?.TimeTracker?.[0]?.startTime).toDateString() === new Date(date).toDateString();
    if (isRunning) {
        const startMinutes = (new Date(runningTask?.TimeTracker?.[0]?.startTime).getHours() * 60) + new Date(runningTask?.TimeTracker?.[0]?.startTime).getMinutes()
        const stopMinutes = (new Date().getHours() * 60) + new Date().getMinutes()
        const startHour = startMinutes / 60;
        const stopHour = stopMinutes / 60;
        activeHours.push([startHour, stopHour])
    }
    return (
        <>
            <Box>
                {hourStrings.map((data) => <Box key={data} sx={hourStyle}>{data}</Box>)}
            </Box>
            <Box sx={{ position: 'relative' }}>
                <Box sx={progressiveBarStyle}>
                    {hourStrings.map((data, index) => {
                        switch (index) {
                            case hourStrings.length - 1:
                                return (
                                    <Box key={data} sx={{ ...oneHourStyle, borderRight: "1px solid #333" }}>
                                        <Box sx={blatStyle} />
                                    </Box>
                                );
                            default:
                                return (
                                    <Box key={data} sx={oneHourStyle}>
                                        <Box sx={blatStyle} />
                                    </Box>
                                );
                        }
                    }
                    )}
                </Box>
                {activeHours.map((data, index) => {
                    const difference = (data[1] - data[0]) * 60 * 60 * 1000
                    const diffHours = Math.floor(difference / (1000 * 60 * 60)).toString().padStart(2, '0')
                    const diffMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0')
                    const left = `${(data[0]) / 24 * 100}%`;
                    const width = `${(data[1] - data[0]) / 24 * 100}%`;
                    const title = `${diffHours}h ${diffMinutes}m`
                    return (
                        <Tooltip key={index} title={title} placement="top">
                            <Box sx={{
                                position: 'absolute',
                                backgroundColor: "#bce078",
                                height: "50%",
                                top: "50%",
                                width,
                                left,
                                opacity: .5,
                                zIndex: 909
                            }}
                            />
                        </Tooltip>
                    )
                })}
            </Box>
        </>
    )
}

const hourStrings = [
    "12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"
]

const hourStyle = {
    width: "4.16666666667%",
    display: "inline-block",
    fontFamily: "OpenSans,sans-serif",
    fontSize: { xs: "5px", md: "10px" },
    color: " #333",
    textAlign: "center"
}

const progressiveBarStyle = {
    borderBottom: "1px solid #333",
    position: "relative",
    zIndex: "1",
    overflow: "hidden"
}

const oneHourStyle = {
    width: "4.16666666667%",
    height: "15px",
    display: "inline-block",
    position: "relative",
    bottom: "-5px",
    textAlign: "center",
    zIndex: "2",
    fontSize: "10px",
    fontWeight: "bolder",
    borderLeft: "1px solid #333",
}

const blatStyle = {
    width: "1px",
    background: "#ababab",
    height: "6px",
    margin: "0 auto",
    position: "relative",
    bottom: "-4px",
}